import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Redirect } from "react-router";
import { MessageStore, UserStore } from "../store";

type IProps = {
  Component: any;
  location?: any;
};

const PrivateRoute = observer(({ Component, location }: IProps) => {
  const [loading, setLoading] = useState(true);
  const authenticated = UserStore.isAthenticated;

  useEffect(() => {
    UserStore.verifyCurrentSession(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return <div></div>;
  if (authenticated) {
    MessageStore.clearMessage();
    return <Component />;
  }

  return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
});

export default PrivateRoute;
